module.exports = __webpack_public_path__ + "assets/img/undraw_forgot_password_gi2d.24021047.svg";